import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { CardHeader } from "../../../components/cards";

import {
  Euro,
  Phone,
  Pin,
  ShoppingCart,
  Star,
  User,
  Users,
} from "lucide-react";
import { useLazyShop } from "../hooks/useShop";

type IShopParams = {
  id: string;
};

export const Shop: React.FC = () => {
  const { id } = useParams<IShopParams>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/shops");
    }
  }, []);

  const [search, { data, loading, error }] = useLazyShop();

  React.useEffect(() => {
    search({ variables: { id: +id! } });
  }, []);

  return (
    <div className="main-container mt-3">
      <section className="section mb-10">
        <div className="w-full mb-2"></div>

        <div className="card mb-2">
          <CardHeader title={data?.shop?.result?.name ?? "Chargement"} />
          <p>
            <div className="flex items-center">
              <Phone size={12} className="mr-2" />
              {data?.shop?.result?.phone}
            </div>
          </p>
          <p>
            <div className="flex items-center">
              <Pin size={12} className="mr-2" />
              {data?.shop?.result?.address}
            </div>
          </p>
          <p>
            {data?.shop?.result?.city} {data?.shop?.result?.postal}
          </p>
          <p>
            <div className="flex items-center">
              <Users size={12} className="mr-2" />
              {data?.shop?.result?.membersCount} collaborateur(s)
            </div>
          </p>
          <p>
            {data?.shop?.result?.rating && data?.shop?.result?.rating > 0 ? (
              <div className="flex items-center">
                <Star size={12} className="mr-2" />
                {data?.shop?.result?.rating}/5
              </div>
            ) : null}
          </p>
        </div>
        <div className="card">
          <CardHeader title="Membres" />
          <ul>
            {data?.shop?.result?.members?.map((member) => (
              <li key={`member-li${member?.id}`}>
                <div
                  className="mb-2"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <User size={16} />
                  <div className="ml-2">
                    <p>{member?.name}</p>
                    <p style={{ fontWeight: "bold" }}>{member?.position}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};
